import React, { useContext } from 'react';
import { KFLTopbar } from '@kamstrup/kamstrup-frontend-library';
import { AppKeys } from '../../core/localization/const';
import { LocaleCtx } from '../../contexts/locale.context';
import useUserEKS from '../../hooks/useUserEKS';
import AppLinks from './appLinks';
import UserLinks from './userLinks';
import ENV from '../../variables';
import { Environments } from '../../variables/const';

interface StateProps {}
type Props = StateProps;
const TopHeader: React.FC<Props> = () => {
  const { isLoggedIn, name, customer } = useUserEKS();
  const { translate } = useContext(LocaleCtx);

  const isDeveloment = [Environments.LOCAL, Environments.NIGHTLY].includes(ENV);

  return (
    <KFLTopbar
      title={translate(AppKeys.topheader_title)}
      username={isLoggedIn ? name : translate(AppKeys.topheader_notloggedin)}
      userDescription={isLoggedIn ? customer?.customerName : ''}
      userLinks={
        <UserLinks isDevelopment={isDeveloment} isLoggedIn={isLoggedIn} />
      }
      appLinks={<AppLinks />}
    />
  );
};

export default TopHeader;
